export const configTypes = {
  GET_CONFIG: '[CONFIG]-GET_CONFIG',
  UPDATE_CONFIG: '[CONFIG]-UPDATE',
};
